import React from "react";
import Container from "react-bootstrap/Container"


const Services = (props) => {

  return (
    <Container>
      <div className="pt-5 d-flex justify-content-center">
        <h2>Services</h2>
      </div>
      <div className="d-flex justify-content-center">
        <h5>We do that, & that, &...</h5>
      </div>
    </Container>
  )
}

export default Services